import React from "react";
import { Table, Icon, Popup, Accordion, List, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";
import { ExternalWorkflowsData } from "../constants/ExternalWorkflows";
import { useMediaQuery } from "react-responsive";

export const ExternalWorkflowHistoryStatusLabel = ({ status }) => {
  switch (status) {
    case "Running":
      return (
        <Popup
          content="Running"
          trigger={
            <Icon
              size="small"
              circular
              inverted
              color="blue"
              name="spinner"
              loading
            />
          }
        />
      );
    case "Succeeded":
      return (
        <Popup
          content="Succeeded"
          trigger={
            <Icon
              size="small"
              circular
              inverted
              color="green"
              name="check circle"
            />
          }
        />
      );
    case "Failed":
      return (
        <Popup
          content="Failed"
          trigger={
            <Icon
              size="small"
              circular
              inverted
              color="red"
              name="times circle"
            />
          }
        />
      );
    case "Error":
      return (
        <Popup
          content="Error"
          trigger={
            <Icon
              size="small"
              circular
              inverted
              color="orange"
              name="exclamation triangle"
            />
          }
        />
      );
    default:
      return (
        <Popup
          content="Unknown"
          trigger={
            <Icon size="small" circular inverted name="question circle" />
          }
        />
      );
  }
};

ExternalWorkflowHistoryStatusLabel.propTypes = {
  status: PropTypes.string,
};

const DesktopHistory = ({ historyData }) => (
  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
    <Table
      compact
      style={{
        width: "100%",
      }}
    >
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>QC Run ID</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {historyData.map((record) => {
          const { workflowExecutionId, createdAt, status } = record;
          const link = `/qc/${workflowExecutionId}/report`;

          return (
            <Table.Row key={workflowExecutionId}>
              <Table.Cell>
                <a href={link}>{workflowExecutionId}</a>
              </Table.Cell>
              <Table.Cell>{new Date(createdAt).toLocaleString()}</Table.Cell>
              <Table.Cell textAlign="center">
                <ExternalWorkflowHistoryStatusLabel status={status} />
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  </div>
);

DesktopHistory.propTypes = {
  historyData: PropTypes.array.isRequired,
};

const MobileHistory = ({ historyData }) => {
  const panels = [
    {
      key: "quality-checks",
      title: {
        content: <span>Quality Checks History</span>,
        icon: "dropdown",
      },
      content: {
        content: (
          <List divided relaxed>
            {historyData.map((record) => {
              const { workflowExecutionId, createdAt, status } = record;
              const link = `/qc/${workflowExecutionId}/report`;

              return (
                <List.Item key={workflowExecutionId}>
                  <Grid columns="equal">
                    <Grid.Column>
                      <a href={link}>{workflowExecutionId}</a>
                      <p style={{ color: "grey", fontSize: "0.9em" }}>
                        {new Date(createdAt).toLocaleString()}
                      </p>
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="right">
                      <ExternalWorkflowHistoryStatusLabel status={status} />
                    </Grid.Column>
                  </Grid>
                </List.Item>
              );
            })}
          </List>
        ),
      },
    },
  ];

  return <Accordion panels={panels} fluid />;
};

MobileHistory.propTypes = {
  historyData: PropTypes.array.isRequired,
};

export const ExternalWorkflowHistory = ({ history }) => {
  const useMockData = false;
  const isMobile = useMediaQuery({ maxWidth: "767px" });

  let historyData = history;
  if (useMockData) {
    historyData = ExternalWorkflowsData;
  }

  if (!historyData || historyData.length === 0) {
    return <p>No quality checks available.</p>;
  }

  return (
    <div>
      {isMobile ? (
        <MobileHistory historyData={historyData} />
      ) : (
        <DesktopHistory historyData={historyData} />
      )}
    </div>
  );
};

ExternalWorkflowHistory.propTypes = {
  history: PropTypes.array,
};
